var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(({ palette }) => ({
    title: {
        lineHeight: 'normal',
        color: palette.primary.contrastText,
    },
}));
const IconContainer = styled.div `
  width: 24px;
  height: 24px;
  margin-right: 8px;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  align-items: center;
  & > * {
    width: 24px;
    height: 24px;
  }
  ${({ theme: { palette } }) => `
    fill: ${palette.primary.contrastText};
    color: ${palette.primary.contrastText};
  `}
`;
const BrandLink = styled(Link).attrs(() => ({
    underline: 'none',
})) `
  display: flex;
  align-items: center;
`;
const BrandContainer = styled.div `
  display: flex;
  flex-grow: 1;
`;
const Brand = (_a) => {
    var { children, href = '/', title } = _a, rest = __rest(_a, ["children", "href", "title"]);
    const classes = useStyles();
    return (React.createElement(BrandContainer, Object.assign({}, rest),
        React.createElement(BrandLink, { href: href },
            children && React.createElement(IconContainer, null, children),
            title && (React.createElement(Typography, { className: classes.title, variant: "h6" }, title)))));
};
Brand.displayName = 'Navbar.Brand';
Brand.propTypes = {
    children: PropTypes.node,
    href: PropTypes.string,
    title: PropTypes.string,
};
const BrandExtra = styled(Brand) ``;
export default BrandExtra;
